import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/**
 * POST /api/transportista/viajes/set-values
 * Contrato QAS: multipart/form-data (PascalCase MxTktH, MxNumeroPedidoH, …; archivos).
 * Auth: Bearer únicamente (no header Key).
 */
@Injectable({ providedIn: 'root' })
export class TransportistaViajesSetValuesGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: FormData,
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/viajes/set-values', body, options);
  }
}
